Customer.Dashboard ||= {}

class Customer.Dashboard.TicketDetailsCountersView extends Backbone.View
  className: 'ticket-counters-stats counter-box-shadow'
  template: JST["backbone/templates/customer/ticket/detail/box/ticket_details_counters"]

  initialize: (@options = {}) ->
    @ticket = @options.ticket
    @ticketCounterCalculator = new Customer.Methods.TicketCounterCalculator(@ticket)

  render: =>
    @$el.html(@template(counters: @counters()))
    @

  startCounting: =>
    setInterval(@render, 1000)

  counters: ->
    firstAssignationCounter = @ticketCounterCalculator.firstAssignationCounter()
    lastAssignationCounter = @ticketCounterCalculator.lastAssignationCounter()
    firstOfTheLastInteractionsCounter = @ticketCounterCalculator.firstOfTheLastInteractionsCounter()
    [
      @counterForView(firstAssignationCounter, 'first-assignation-counter', 'Ticket lifetime value: ')
      @counterForView(lastAssignationCounter, 'last-assignation-counter', 'Assigned Time: ')
      @counterForView(firstOfTheLastInteractionsCounter, 'first-of-the-last-interactions-counter', 'Response Time: ')
    ]

  counterForView: (counter, id, label) =>
    {
      id: id
      label: id.replace(/-/g, '_') 
      counterString: @counterString(counter.difference)
      alert: "counter-#{counter.alert}-alert"
    }

  counterString: (difference) =>
    sign = if difference.negative then "-" else " "
    "#{sign} #{difference.hours} : #{difference.minutes} : #{difference.seconds}"